import { UserMissionHistoryPage } from './UserMissionHistoryPage'
import { withUserMissionHistoryPage } from './withUserMissionHistoryPage'

const Connected = withUserMissionHistoryPage(UserMissionHistoryPage)

export { Connected as UserMissionHistoryPage }
